import React from 'react';
import PropTypes from 'prop-types';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftSelect from 'components/SoftSelect';

const DocumentTypeSelector = ({ selectedDocumentType, setSelectedDocumentType }) => {
  const documentTypeOptions = [
    { value: 'RECIBO BODEGA', label: 'Recibo bodega' },
    { value: 'EMBARQUE', label: 'Embarque' },
    { value: 'FACTURA', label: 'Factura' },
    { value: 'FOTO', label: 'Foto' },
    { value: 'VARIOS', label: 'Varios' },
  ];

  return (
    <SoftBox>
      <SoftTypography variant="caption" fontWeight="bold" color="text">
        Tipo de Documento
      </SoftTypography>
      <SoftSelect
        options={documentTypeOptions}
        value={documentTypeOptions.find(option => option.value === selectedDocumentType)}
        onChange={(option) => setSelectedDocumentType(option ? option.value : null)}
        placeholder="Seleccione un tipo de documento"
      />
    </SoftBox>
  );
};

DocumentTypeSelector.propTypes = {
  selectedDocumentType: PropTypes.string, // Ahora se espera un string
  setSelectedDocumentType: PropTypes.func.isRequired,
};

export default DocumentTypeSelector;
